import App from "./app";

const loadMainWebpage = async () => {
  document.getElementById("main").appendChild(await App());
  document.querySelector("#current-year").innerHTML = new Date().getFullYear();
};
// Load main page
loadMainWebpage();
